const moduleMap = {
	"./PluginConfiguration": () => {
		return Promise.all([__webpack_require__.e(7930), __webpack_require__.e(9324), __webpack_require__.e(8835), __webpack_require__.e(9191), __webpack_require__.e(777), __webpack_require__.e(5931), __webpack_require__.e(9302), __webpack_require__.e(318), __webpack_require__.e(4443), __webpack_require__.e(4899), __webpack_require__.e(9858), __webpack_require__.e(4208), __webpack_require__.e(685)]).then(() => (() => ((__webpack_require__(9873)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});